import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "QuotationItemEventItemActivityListPage" */
	'pages/sales/QuotationItemEventItemActivity/QuotationItemEventItemActivityListPage'));

export default [{ component, exact: true, path: '/sub_partitions/:subPartitionId/quotation_item_event_item_activities' }];